module.exports = __webpack_public_path__ + "static/img/PK@2x.d831e1c3.jpg";